import React, { useState, useEffect } from "react";
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn,
  MDBIcon,
  MDBSpinner,
} from "mdb-react-ui-kit";
import fetchScheduledBills from "../../utils/fetchScheduledBills";
import fetchBillDetailsWithBillId from "../../utils/fetchBillDetailsWithBillId";
import fetchBillsWithSponsors from "../../utils/fetchBillsWithSponsors";
// import fetchExhibits from "../../utils/fetchExhibits";
import { getDocumentUrl } from "../../utils/getDocumentUrl";
import printAgendaPDF from "../../utils/printAgendaPDF";
import axios from "axios";

const AgendaModal = ({ meeting, open, setOpen, legislatureOrdinal }) => {
  const committeeName =
    meeting?.standingCommittee?.committeeDetails?.committeeCode?.name;
    const committeeCode = meeting?.standingCommittee
    ?.committeeDetails
    ?.committeeCode
    ?.code;
  const location = meeting?.location || "TBD";
  const meetingTime = meeting?.meetingTime;
  const publicParticipation = meeting?.publicParticipation;
  const [scheduledBills, setScheduledBills] = useState([]);
  const [agendaItems, setAgendaItems] = useState([]);
  // const [exhibits, setExhibits] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getAgendaData = async () => {
      setLoading(true);
      try {
        // get the list of scheduled‐bill
        const refs = await fetchScheduledBills(meeting.id);

        // fetch & attach each billNumber & title
        const detailed = await Promise.all(
          refs.map(async (ref) => {
            const meta = await fetchBillDetailsWithBillId(ref.billId);

            return {
              billId: ref.billId,
              status: ref.status,
              ...meta,
            };
          })
        );
        setScheduledBills(detailed);

        // fetch & attach each bill’s sponsor object
        const withSponsors = await fetchBillsWithSponsors(detailed);

        setScheduledBills(withSponsors);
        // load other agenda items
        const agendaRes = await axios.get(
          `${process.env.REACT_APP_LAWS_BACKEND_HOST}/committees/v1/standingCommitteeAgendaItems/findByCommitteeMeetingId`,
          { params: { committeeMeetingId: meeting.id } }
        );
        setAgendaItems(agendaRes.data.content);

        // 4) load exhibits
        // const exhibitsData = await fetchExhibits({
        //   legislatureOrdinal: legislatureOrdinal,
        //   committeeType:
        //     meeting.standingCommittee.committeeDetails.committeeCode
        //       .committeeType.id,
        //   committeeTypeCode:
        //     meeting.standingCommittee.committeeDetails.committeeCode
        //       .committeeType.code,
        //   committeeCode:
        //     meeting.standingCommittee.committeeDetails.committeeCode.code,
        //   chamber: meeting.standingCommittee.chamber,
        //   meetingDateTime: meeting.meetingTime,
        // });
        // setExhibits(exhibitsData);
      } catch (err) {
        console.error("Error in getAgendaData:", err);
      } finally {
        setLoading(false);
      }
    };
    if (open && meeting) getAgendaData();
  }, [open, meeting]);

  if (!open) {
    return null;
  }

  const handleExhibitClick = async (docId) => {
    try {
      const url = await getDocumentUrl(docId);
      window.open(url, "_blank");
    } catch (error) {
      console.error("Error opening exhibit document:", error);
    }
  };

  return (
    <MDBModal open={open} tabIndex="-1" setOpen={setOpen}>
      <MDBModalDialog size="xl">
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle className="w-100">Agenda Items</MDBModalTitle>
            <MDBBtn
              className="text-nowrap me-3"
              onClick={() =>
                printAgendaPDF({
                  committeeName,
                  committeeCode,
                  location,
                  meetingTime,
                  scheduledBills,
                  agendaItems,
                  publicParticipation,
                })
              }
            >
              <MDBIcon fas icon="print" /> Print
            </MDBBtn>
            <MDBBtn
              className="btn-close"
              color="none"
              onClick={() => setOpen(false)}
            />
          </MDBModalHeader>
          <MDBModalBody>
            {meeting && (
              <div className="mb-2 text-center">
                <strong>
                  <p className="mb-1">{committeeName}</p>
                  {new Intl.DateTimeFormat("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "2-digit",
                    hour: "numeric",
                    minute: "2-digit",
                    hour12: true,
                  }).format(new Date(meeting.meetingTime))}
                  , {meeting.location}
                </strong>
              </div>
            )}

            {loading ? (
              <div className="text-center">
                <MDBSpinner />
              </div>
            ) : (
              <>
                <h3>Scheduled Bills</h3>
                {scheduledBills.length > 0 ? (
                  <ul>
                    {scheduledBills.map((b) => {
                      const name = b.sponsor
                        ? `${b.sponsor.lastName}, ${b.sponsor.firstName}`
                        : "Unknown";
                      return (
                        <li key={b.billId}>
                          {b.billType.code} {b.billNumber}: {b.draft.shortTitle}{" "}
                          - Sponsor: {name}
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <ul>
                    <li>None</li>
                  </ul>
                )}

                <h3>Other Agenda Items</h3>
                {agendaItems && agendaItems.length > 0 ? (
                  <ul>
                    {agendaItems.map((item, idx) => (
                      <li key={idx}>
                        <strong>{item.title}:</strong> {item.description}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <ul>
                    <li>None</li>
                  </ul>
                )}

                {meeting && (
                  <>
                    <h3>Notes</h3>
                    <ul className="no-bullet">
                      <li>
                        <strong>Accepting Online Public Comment:</strong>{" "}
                        {meeting.publicParticipation ? "Yes" : "No"}
                      </li>
                    </ul>
                  </>
                )}

                {/* <h3>Exhibits</h3>
                {exhibits && exhibits.length === 0 ? (
                  <ul>
                    <li>None</li>
                  </ul>
                ) : (
                  <ul>
                    {exhibits.map((item, idx) => (
                      <li key={idx}>
                        <MDBBtn
                          color="none"
                          tag="a"
                          title="View Exhibit"
                          onClick={(e) => {
                            e.preventDefault();
                            handleExhibitClick(item.id);
                          }}
                        >
                          <MDBIcon far icon="file-alt" />{" "}
                          {item.documentTitle || `Exhibit ${idx 1}`}
                        </MDBBtn>
                      </li>
                    ))}
                  </ul>
                )} */}
              </>
            )}
            <div className="text-center">
              <small className="text-muted">
                Agenda subject to change at anytime.
              </small>
            </div>
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn color="dark" onClick={() => setOpen(false)}>
              Close
            </MDBBtn>
          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
};
export default AgendaModal;
